/*
 * SimpleTableHeader.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Thu Mar 02 2023 mys Company
 */

import { localization } from '../../../config/localize/localizable'

const SimpleTableHeaders = ({ items }) => {
    return (
        <>
            {items &&
                items.map((item, index) => {
                    return <th key={index}>{localization[item] ?? item}</th>
                })}
        </>
    )
}

export default SimpleTableHeaders
